module.exports = __webpack_public_path__ + "img/book-05.9c7493bf.png";